import { render, staticRenderFns } from "./mstradvcategory.vue?vue&type=template&id=3894a9de"
import script from "./mstradvcategory.vue?vue&type=script&lang=js"
export * from "./mstradvcategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports